<template>
    <el-dialog :visible="true" :close-on-click-modal="false" width="400px" :before-close="cancel">
        <div class="result-content">
            <div class="status-info">
                创建邀请成功！
            </div>
            <p class="info">请将邀请链接发送给up主，完成关联</p>
            <p class="info-url">{{inviteUrl + appId}}</p>
            <el-button type="primary" plain @click="copy">复制链接</el-button>
            <textarea class="textarea" rows="1" cols="1" ref="text"></textarea>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        props: {
            appId: {
                type: String,
                default: ''
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                inviteUrl: 'https://miniapp.bilibili.com/invite/smallappinvite.html?appId=',
            }
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            },
            copy(text) {
                let copyInput = this.$refs.text;
                copyInput.value = this.inviteUrl + this.appId;
                copyInput.select();
                document.execCommand('copy');
                this.$message.success('复制成功！');
            }
        }
    }
</script>
<style lang="less" scoped>
.result-content {
    text-align: center;
    font-size: 14px;
    color: #5C667E;
    position: relative;
    .status-info {
        font-weight: 500;
    }
    .info-url {
        margin-bottom: 20px;
    }
    .textarea {
        position: absolute;
        bottom: 10px;
        left: 110px;
        z-index: -1;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/manage/ResultDialog.vue